import type { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { ListItem, type ListItemProps, ListItemText, ListItemIcon } from '@dhl-ui/components'
import { ChevronRightIcon } from '@dhl-ui/icons'

type LinkMenuItemProps = Omit<ListItemProps, 'alignItems' | 'isButton' | 'isDense' | 'isVertical' | 'slotProps'> & {
  /**
   * Text inside our menu item
   */
  label: string

  /**
   * Icon which visually supports the label
   */
  icon: ReactElement
}

export const LinkMenuItem: FC<LinkMenuItemProps> = ({ label, icon, to, sx, ...rest }) => (
  <ListItem
    {...rest}
    to={to}
    isDense
    isButton={!to}
    alignItems="center"
    slotProps={{ secondaryIcon: <ChevronRightIcon /> }}
    Component={to ? Link : undefined}
    sx={{ ...sx, px: 2 }}
  >
    <ListItemIcon isBlock>{icon}</ListItemIcon>
    <ListItemText primary={label} />
  </ListItem>
)
